var portfolioBreakdown = {
	table: {
		caption: "Portfolio Breakdown",
		name: {
			assetClass: "Asset class",
			currency: "Currency",
			sector: "Sector"
		}
	},
	chart: {
		counting: {
			assetClass: "Activaklassen",
			currency: "Valuta's",
			sector: "Sectoren"
		},
		topPositions: {
			assetClass: "Top asset classes",
			currency: "Top currencies",
			sector: "Top sectors"
		}
	},
	assetClasses: {
		bond: "Obligatie",
		commodity: "Commodity",
		currency: "Valuta",
		debt: "Debt",
		etf: "ETF",
		fund: "Fonds",
		generic: "Algemeen",
		index: "Index",
		stock: "Aandeel",
		interestRate: "Rente",
		structuredProduct: "Gestructureerd Product",
		investmentProduct: "Investeringsproduct",
		leveragedProduct: "Hefboomproduct",
		option: "Optie",
		future: "Future"
	}
};
var nl = {
	portfolioBreakdown: portfolioBreakdown
};

export { nl as default, portfolioBreakdown };
